import GuestFavouritesSection from './GuestFavouritesSection';

export default GuestFavouritesSection;
